var _ = Object.defineProperty;
var h = (e, t, a) => t in e ? _(e, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[t] = a;
var v = (e, t, a) => (h(e, typeof t != "symbol" ? t + "" : t, a), a);
import { defineComponent as x, ref as k, computed as w, openBlock as g, createElementBlock as b, Fragment as C, renderList as B, normalizeClass as y, createElementVNode as d, toDisplayString as u, defineCustomElement as I } from "vue";
const n = class n {
  constructor(t) {
    v(this, "_options");
    this._options = t;
  }
  static getInstance(t) {
    return n._instance || (n._instance = new n(t)), n._instance;
  }
  static resetInstance() {
    this._instance = null;
  }
  get options() {
    return this._options;
  }
};
v(n, "_instance");
let c = n;
const E = [
  {
    id: "0b0b9051-d5c6-4d96-9768-b492ac6e4888",
    display_name: "Bancolombia",
    icon_logo: "https://statics.belvo.io/institutions/icon_logos/bancolombia.svg"
  },
  {
    id: "2f0c4787-d869-412c-92f7-28b9b3e9367f",
    display_name: "Daviplata",
    icon_logo: "https://statics.belvo.io/institutions/icon_logos/daviplata_icon.svg"
  },
  {
    id: "aaa29512-5a13-4763-9878-538a59f162a6",
    display_name: "Nequi",
    icon_logo: "https://statics.belvo.io/institutions/icon_logos/nequi_icon.svg"
  }
], z = [
  {
    id: "12b8611a-e66a-413a-b819-deb3dc6c62de",
    display_name: "Nubank",
    icon_logo: "https://statics.belvo.io/institutions/icon_logos/nubank_icon.svg"
  },
  {
    id: "ecdae9f4-4b40-49a6-97b9-05312b4b2759",
    display_name: "Santander",
    icon_logo: "https://statics.belvo.io/institutions/icon_logos/santander.svg"
  },
  {
    id: "1701f9d9-e8b3-4c88-ad2f-7fb4d32867d4",
    display_name: "Caixa",
    icon_logo: "https://statics.belvo.io/institutions/icon_logos/caixa.svg"
  },
  {
    id: "7def383a-f956-4010-b934-a8bfe0ac7dbf",
    display_name: "Banco do Brasil",
    icon_logo: "https://statics.belvo.io/institutions/icon_logos/bancodobrasil.svg"
  },
  {
    id: "40f23107-b5c3-4c0a-8d78-6542a6d57640",
    display_name: "Bradesco",
    icon_logo: "https://statics.belvo.io/institutions/icon_logos/bradesco.svg"
  }
], S = {
  COL: E,
  BRA: z
}, j = { class: "belvo-payments-grid" }, L = ["onClick"], D = ["src"], O = /* @__PURE__ */ x({
  __name: "BelvoPaymentsGrid.ce",
  props: {
    country: {
      type: String,
      default: "COL"
    },
    anotherInstitutionText: {
      type: String,
      default: "Another institution"
    }
  },
  setup(e) {
    const t = e, a = c.getInstance(), l = S, s = k(""), f = w(() => l[t.country]), p = (i) => [
      { "belvo-payments-grid__card": !0 },
      { "belvo-payments-grid__card--selected": s.value === i }
    ], m = (i) => {
      var r, o;
      s.value = i == null ? void 0 : i.id, (o = (r = a.options) == null ? void 0 : r.bankShortcuts) == null || o.callback(i);
    };
    return (i, r) => (g(), b("ul", j, [
      (g(!0), b(C, null, B(f.value, (o) => (g(), b("li", {
        key: o.id,
        class: y(p(o.id)),
        onClick: (T) => m(o)
      }, [
        d("img", {
          src: o.icon_logo
        }, null, 8, D),
        d("span", null, u(o.display_name), 1)
      ], 10, L))), 128)),
      d("li", {
        class: y([p(), "belvo-payments-grid__card--another-institution"]),
        onClick: r[0] || (r[0] = (o) => m())
      }, [
        d("span", null, u(e.anotherInstitutionText), 1)
      ], 2)
    ]));
  }
}), q = ".belvo-payments-grid[data-v-f157a9da]{display:grid;margin:0;grid-template-columns:var(--belvo-payments-grid-template-columns, 1fr);grid-template-rows:var(--belvo-payments-grid-template-rows, 1fr 1fr 1fr 1fr);padding:var(--belvo-payments-grid-padding, 1rem);border-style:var(--belvo-payments-grid-border-style, solid);border-width:var(--belvo-payments-grid-border-width, .0125rem);border-color:var(--belvo-payments-grid-border-color, #e2e2e2);border-radius:var(--belvo-payments-grid-border-radius, .25rem);background-color:var(--belvo-payments-grid-background-color, #ffffff);gap:var(--belvo-payments-grid-gap, 1rem)}.belvo-payments-grid__card[data-v-f157a9da]{display:flex;align-items:var(--belvo-payments-grid-card-align-items, center);justify-content:var(--belvo-payments-grid-card-justify-content, flex-start);cursor:var(--belvo-payments-grid-card-cursor, pointer);border-style:var(--belvo-payments-grid-card-border-style, solid);border-width:var(--belvo-payments-grid-card-border-width, .0125rem);border-color:var(--belvo-payments-grid-card-border-color, #e2e2e2);border-radius:var(--belvo-payments-grid-card-border-radius, .25rem);background-color:var(--belvo-payments-grid-card-background-color, #f0f2f4);padding:var(--belvo-payments-grid-card-padding, .5rem);transition-duration:var(--belvo-payments-grid-card-transition-duration, .3s);transition-property:var(--belvo-payments-grid-card-transition-property, border-color, box-shadow);transition-timing-function:var(--belvo-payments-grid-card-transition-timing-function, cubic-bezier(.4, 0, .2, 1))}.belvo-payments-grid__card[data-v-f157a9da]:hover:not(.belvo-payments-grid__card--selected){box-shadow:var(--belvo-payments-grid-card-hover-box-shadow, 0 0 0 6px #9cc1fc);background-color:var(--belvo-payments-grid-card-hover-background-color, #e6effe)}.belvo-payments-grid__card--selected[data-v-f157a9da]{box-shadow:var(--belvo-payments-grid-card-selected-box-shadow, 0 0 0 2px #0663f9, 0 0 0 6px #9cc1fc)}.belvo-payments-grid__card:not(.belvo-payments-grid__card--another-institution) span[data-v-f157a9da]{display:var(--belvo-payments-grid-card-institution-text-display, inherit);font-family:var(--belvo-payments-grid-card-institution-text-font-family, inherit);font-size:var(--belvo-payments-grid-card-institution-text-font-size, 1rem);font-weight:var(--belvo-payments-grid-card-institution-text-font-weight, 600);color:var(--belvo-payments-grid-card-institution-text-color, #000000)}.belvo-payments-grid__card:not(.belvo-payments-grid__card--another-institution) img[data-v-f157a9da]{display:var(--belvo-payments-grid-card-institution-image-display, inherit);width:var(--belvo-payments-grid-card-institution-image-width, 2rem);height:var(--belvo-payments-grid-card-institution-image-height, 2rem);margin-right:var(--belvo-payments-grid-card-institution-image-margin-right, .25rem)}.belvo-payments-grid__card--another-institution[data-v-f157a9da]{justify-content:var(--belvo-payments-grid-card-another-institution-justify-content, center)}.belvo-payments-grid__card--another-institution span[data-v-f157a9da]{display:var(--belvo-payments-grid-card-another-institution-text-display, inherit);font-family:var(--belvo-payments-grid-card-another-institution-text-font-family, inherit);font-size:var(--belvo-payments-grid-card-another-institution-text-font-size, 1rem);font-weight:var(--belvo-payments-grid-card-another-institution-text-font-weight, 600);color:var(--belvo-payments-grid-card-another-institution-text-color, #000000)}", A = (e, t) => {
  const a = e.__vccOpts || e;
  for (const [l, s] of t)
    a[l] = s;
  return a;
}, G = /* @__PURE__ */ A(O, [["styles", [q]], ["__scopeId", "data-v-f157a9da"]]), N = (e, t) => {
  if (customElements.get(e))
    return;
  const a = I(t);
  customElements.define(e, a);
}, R = (e) => {
  e.forEach((t) => {
    N(t.name, t.setup);
  });
}, F = {
  init: (e) => {
    c.getInstance(e), R([{ name: "belvo-payments-grid", setup: G }]);
  }
};
export {
  F as default
};
